import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/exam-management/descriptive`;

export const descriptiveExamManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create/:courseId`,
  edit: `${baseRoute}/edit/:courseId/:descriptiveExamId`,
  view: `${baseRoute}/view/:courseId`,
} as const;

export type IDescriptiveExamManagementRouteParams = IExtractRouteParamMap<
  typeof descriptiveExamManagementRoutesObj
>;

export const descriptiveExamManagementPath = createPaths<
  typeof descriptiveExamManagementRoutesObj,
  IDescriptiveExamManagementRouteParams
>(descriptiveExamManagementRoutesObj);
